module.exports = {
	"articleTitle1": "Pocket Points application encourages student attention during class",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Pita Kabob Grill",
	"articleLink1": "#",
	"articleLink2": "https://www.michigandaily.com/news/new-mediterranean-restaurant-lands-south-state-street",
	"articleSnippet1": "Feb 10, 2015 ... The restaurants currently included are Pita Pit, The Brown Jug, The Blue ... Some \nBurritos, Hunter House Hamburgers, Pita Kabob Grill, Pita Pit, ...",
	"articleSnippet2": "Mar 15, 2011 ... But Christine McGinn, an employee at Pita Kabob Grill on East William Street, \nsaid the addition of another Mediterranean restaurant will likely ...",
	"foodRecommendations": [
		{
			"text": "It's amazing. The kabobs are delicious.",
			"person": "Marisa Iaderosa"
		}
	],
	"articleTitle2": "New State Street Mediterranean restaurant to open during summer",
	"address": "619 E William St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.277956,
		"lng": -83.741135
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/pitakabob.json
// module id = 948
// module chunks = 0